import React, { useState } from 'react';
import ClasseFilAnnuel from 'components/ClasseFilAnnuel';
import ClassWorkspaceLayout from 'components/ClassWorkspaceLayout';

import axios from 'axios';
import { useSelector, useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom';

export default function FilAnnuel(props) {
    const nbEleve = useSelector(state => state.eleveNb.eleve.nb_eleve)

    const [idClasse, setIdClasse] = useState();
    const [niveauClasse, setNiveauClasse] = useState();
    const [nomClasse, setNomClasse] = useState();
    const [positionEleve, setPositionEleve] = useState();

    const dispatch = useDispatch()
    const history = useHistory()
    const classDetail = props.location && props.location.state && props.location.state.detail

    const user_connected = useSelector(state => state.userConnected.user_connected)

    React.useEffect(() => {
        if (!classDetail) {
            history.replace('/compte')
            return
        }

        setIdClasse(classDetail.id_classe)
        setNiveauClasse(classDetail.niveau)
        setNomClasse(classDetail.nom_classe + ' ' + classDetail.nom_etablissement)
        setPositionEleve(classDetail.position)

        axios.get('https://eps.acces-editions.com/api/getEleve', {
            params: { id_classe: classDetail.id_classe, _: Date.now() },
        })
        .then((res) => {
            if(res.data[0] !== undefined)
            {
                dispatch({ type: 'user/eleveDetail', payload: res.data })
                dispatch({ type: 'user/eleveNb', payload: { nb_eleve: res.data.length }})
            } else {
                dispatch({ type: 'user/eleveDetail', payload: [] })
                dispatch({ type: 'user/eleveNb', payload: { nb_eleve: 0 }})
            }
        })
        .catch(() => {
            dispatch({ type: 'user/eleveDetail', payload: [] })
            dispatch({ type: 'user/eleveNb', payload: { nb_eleve: 0 }})
        })
    }, [classDetail, dispatch, history]);

    if (!classDetail) return null

    return (
        <ClassWorkspaceLayout
            title="Fil annuel"
            subtitle="Visualisez la synthèse des disciplines abordées sur la période de votre choix."
            classLabel={nomClasse}
            studentCount={nbEleve}
            levels={niveauClasse}
            user={user_connected}
        >
            <ClasseFilAnnuel idClasse={idClasse} positionEleve={positionEleve} suivi={false} />
        </ClassWorkspaceLayout>
    );
}
